import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '@repo/ui/src/lib/utils';
import { SubscriptionTab } from '../../billing/components/SubscriptionTab';
import { InvoicesTab } from '../../billing/components/InvoicesTab';

type Tab = 'subscription' | 'invoices';

// The old BillingPage body (two sub-tabs), minus its own PageHeader — the
// section title/description is rendered by SettingsLayout.
export function BillingSection() {
  const { t } = useTranslation('billing');
  const [tab, setTab] = useState<Tab>('subscription');
  return (
    <div>
      <div className="flex gap-1 border-b border-surface-200 mb-4">
        {(['subscription', 'invoices'] as const).map((k) => (
          <button
            key={k}
            type="button"
            onClick={() => setTab(k)}
            className={cn(
              'px-4 py-2 text-[13px] font-medium border-b-2 -mb-px transition-colors',
              tab === k ? 'border-brand-500 text-brand-700' : 'border-transparent text-surface-500 hover:text-surface-700',
            )}
          >
            {t(`tabs.${k}`)}
          </button>
        ))}
      </div>
      {tab === 'subscription' ? <SubscriptionTab /> : <InvoicesTab />}
    </div>
  );
}
